'use strict';

const { init, isIOSSafari } = require('./login/loginPopupUtil');

var loginPopup = $('.sign-up-section');
var resendLink = $('#resendLink');
var otpPopup = $('.otp-verification-section');
var registerForm = $('#registration-form');
var registerpopup = $('.registration-form-section');
var { grecaptchaGenerateToken } = require('./common/grecaptchaUtils');

/**
 * Validates the name field input for minimum length and alphabet-only characters.
 *
 * @param {jQuery} $field - The jQuery-wrapped input field to validate.
 */
function checkFirstName($field) {
    var nameValue = $field.val().trim();
    var regName = /^[a-zA-Z0-9.]+$/; // Allow letters, numbers, and dots
    var minlength = $field.attr('minlength');

    if (nameValue.length >= minlength && regName.test(nameValue)) {
        $field.parent().removeClass('error-class').addClass('valid-input');
        $field.siblings('.error-message').addClass('d-none');
        $field.siblings('.py-cross-right').removeClass('d-none');
    } else {
        $field.parent().addClass('error-class').removeClass('valid-input');
        $field.siblings('.error-message').removeClass('d-none');
        $field.siblings('.py-cross-right').addClass('d-none');
    }
}

/**
 * Validates the name field input for minimum length and alphabet-only characters.
 *
 * @param {jQuery} $field - The jQuery-wrapped input field to validate.
 */
function checkLastName($field) {
    var nameValue = $field.val().trim();
    var regName = /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)?$/; // Allow letters, numbers, and single spaces between words
    var minlength = $field.attr('minlength');

    if (nameValue.length >= minlength && regName.test(nameValue)) {
        $field.parent().removeClass('error-class').addClass('valid-input');
        $field.siblings('.error-message').addClass('d-none');
        $field.siblings('.py-cross-right').removeClass('d-none');
    } else {
        $field.parent().addClass('error-class').removeClass('valid-input');
        $field.siblings('.error-message').removeClass('d-none');
        $field.siblings('.py-cross-right').addClass('d-none');
    }
}
$('.register-form-firstname').on('input', function () {
    let cleaned = $(this).val().replace(/[^a-zA-Z0-9.]/g, '');
    $(this).val(cleaned);
});

$('.register-form-lastname').on('input', function () {
    let cleaned = $(this).val()
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/^\s+/, '');
    let parts = cleaned.split(' ');
    if (parts.length > 2) {
        cleaned = parts[0] + ' ' + parts[1];
    }

    $(this).val(cleaned);
});

/**
 * Validates the Email field.
 * - Ensures the input is not empty and follows a valid email pattern (letters, numbers, @, and .).
 * - Shows or hides the error message and clear icon based on validation.
 */
function checkEmail() {
    var emailField = $('.registerpopup-formdiv #email');
    var emailValue = emailField.val().trim();
    var regExpEmail = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;

    if (emailValue === '' || !regExpEmail.test(emailValue)) {
        emailField.parent().addClass('error-class').removeClass('valid-input');
        $('#blank-email').removeClass('d-none');
        emailField.siblings('.py-cross-right').addClass('d-none');
    } else {
        emailField.parent().removeClass('error-class').addClass('valid-input');
        $('#blank-email').addClass('d-none');
        emailField.siblings('.py-cross-right').removeClass('d-none');
    }
}
$('.py-cross-right').on('click', function () {
    var inputField = $(this).closest('.py-form-field').find('input');
    var fieldName = inputField.attr('name');
    inputField.val('');
    $(this).addClass('d-none');

    if (fieldName === 'firstName') {
        $('#blank-firstname').removeClass('d-none');
        checkFirstName($('#first-name'));
    } else if (fieldName === 'lastName') {
        $('#blank-lastname').removeClass('d-none');
        checkLastName($('#last-name'));
    } else if (fieldName === 'email') {
        inputField.parent().addClass('error-class');
        $('#blank-email').removeClass('d-none');
        checkEmail();
    }
});
/**
 * Prevents changes to a phone number input field by making it readonly
 * and resetting its value if the user tries to modify it.
 *
 * @param {jQuery} phoneInput - The jQuery object representing the phone number input field.
 * @param {string} originalPhone - The original phone number value that should not be changed.
 */
function preventPhoneNumberChange(phoneInput, originalPhone) {
    // Set the value and readonly
    phoneInput.val(originalPhone);
    phoneInput.find('.phone-label-group').prop('readonly', true);
    phoneInput.attr('autocomplete', 'off');
    phoneInput.addClass('disabled-field cursor-custom-not-allowed');

    phoneInput.on('input', function () {
        if ($(this).val() !== originalPhone) {
            $(this).val(originalPhone);
        }
    });
}

/**
 * Set the colour and font of the resend link
 */
function hideCountDown() {
    $('#some-div').html('');
    $('#some-div').css('opacity', '0');
    resendLink.addClass('custom-color').removeAttr('disabled');
}

/**
 * Show the countdown when click on resend link
 */
function showCountDownOnResendLink() {
    $('#some-div').css('opacity', '1');
    resendLink.removeClass('custom-color');
    resendLink.attr('disabled', true);
}

var timeLeft;
var timerId;
/**
 * Reverse count down for otp
 */
function countdown() {
    if (timeLeft === -1) {
        clearTimeout(timerId);
        if (window.isTimer) {
            window.isTimer = false;
        }
        hideCountDown();
    } else {
        if (!window.isTimer) {
            window.isTimer = true;
        }
        var sec = timeLeft;
        var minute = '0' + parseInt((sec / 60), 10);
        var secondintial = parseInt(sec - (minute * 60), 10);
        var second;
        if (secondintial < 10) {
            second = '0' + secondintial;
        } else {
            second = secondintial;
        }
        var timer2 = minute + ':' + second;
        $('#some-div').html('<span class="count d-flex"> in <div class="count-value"> ' + timer2 + ' </div></span>');
        timeLeft -= 1;
    }
}

/**
 * Starts a countdown timer from 2.30 mins.
 * Resets the timer if it is already running.
 */
function startCountdown() {
    timeLeft = 151;
    if (timerId) {
        clearTimeout(timerId);
    }
    countdown();
}

/**
 * Remove errors and handle stying through classes
 * @param {HTMLElement} element the parent div for input
 *
 */
function addFieldErrors(element) {
    element.parent('.phoneno-field').addClass('error');
    element.closest('.input-group').addClass('error');
    element.find('.login-phone-field').removeClass('input-filled');
}

/**
 * Remove errors and handle stying through classes
 * @param {HTMLElement} element the parent div for input
 *
 */
function removeFieldErrors(element) {
    element.parent('.phoneno-field').removeClass('error');
    element.closest('.input-group').removeClass('error');
    element.find('.login-phone-field').addClass('input-filled');
}

/**
 * Set a class that is reflecting it to disabled
 * @param {HTMLElement} ele selected input for phone number
 *
 */
function loginValidation(ele) {
    var $parentEle = $(ele).closest('.phoneno-field');
    $parentEle.find('#default-error').removeClass('d-block');
    var minLength = $(ele).attr('minlength');
    var maxLength = $(ele).attr('maxlength');
    var mobile = $(ele).val();
    var phoneNolength = $(ele).val().length;
    removeFieldErrors($parentEle);
    $parentEle.find('#valid-error').removeClass('d-block');
    $parentEle.find('.responsemessage').addClass('d-none');
    if (mobile !== '') {
        if (phoneNolength < minLength || phoneNolength > maxLength) {
            $parentEle.find('#valid-error').addClass('d-block');
            $parentEle.find('#default-error').addClass('d-none');
            addFieldErrors($parentEle);
            $parentEle.parents('.loginpopup-formdiv').find('.loginpopup-submitbutton').attr('disabled', 'disabled');
        } else {
            $parentEle.find('#valid-error').removeClass('d-block');
            removeFieldErrors($parentEle);
            $parentEle.parents('.loginpopup-formdiv').find('.loginpopup-submitbutton').removeAttr('disabled');
        }
        clearTimeout(timerId);
        countdown();
        showCountDownOnResendLink();
        timerId = setInterval(countdown, 1000);
        $('.otp-input')[0].focus();
    } else {
        $parentEle.find('#default-error').addClass('d-block');
        addFieldErrors($parentEle);
        $parentEle.parents('.loginpopup-formdiv').find('.loginpopup-submitbutton').attr('disabled', 'disabled');
    }
}

/**
 * countdown timer for sync
 */
function countdownWithSync() {
    if ($('#some-div').text().indexOf('0:0') > 0) {
        hideCountDown();
    } else {
        $('#some-div .count').text($('#timer-some-div').text());
    }
}

/**
 * Gets csrf token for login form
 * @returns {Object} csrf token object
 */
function getCSRFTokenForLogin() {
    return {
        csrfTokenName: $('.loginCSRFToken').attr('name'),
        csrfTokenValue: $('.loginCSRFToken').val()
    };
}

$('body').on('click', '.loginpopup-submitbutton', async function (e) {
    e.preventDefault();
    var parent = $(this).closest('.loginpopup-formdiv');
    var phoneNumber = parent.find('.phone-number-field');
    var minLength = phoneNumber.find('.login-phone-field').attr('minlength');
    var maxLength = phoneNumber.find('.login-phone-field').attr('maxlength');
    var mobile = phoneNumber.find('.login-phone-field').val();
    var phoneNolength = mobile.length;
    var regexExp = /^[6-9]\d{9}$/g;
    var element = parent.find('.form-field');
    var countryCode = $('#loginCountryDropdown').val();
    var locale = $('.login-dropdown .py-option-value.selected').data('value');
    if (locale) {
        locale = locale.toLowerCase();
    }
    var { csrfTokenName, csrfTokenValue } = getCSRFTokenForLogin();
    if (mobile !== '') {
        if (phoneNolength < minLength || phoneNolength > maxLength) {
            parent.find('#valid-error').addClass('d-block');
            parent.find('.phoneno-field').addClass('error');
            addFieldErrors(element);
        } else if (countryCode === '+91' && !regexExp.test(mobile)) {
            parent.find('#valid-error').addClass('d-block');
            parent.find('.phoneno-field').addClass('error');
            addFieldErrors(element);
        } else {
            parent.find('#valid-error').removeClass('d-block');
            parent.find('.phoneno-field').removeClass('error');
            removeFieldErrors(element);
            var formData = {
                mobile: mobile,
                countryCode: countryCode,
                locale: locale,
                recaptchaToken: await grecaptchaGenerateToken()
            };
            formData[csrfTokenName] = csrfTokenValue;
            $.ajax({
                url: $(this).data('requestotpurl'),
                method: 'post',
                dataType: 'json',
                data: formData,
                success: function (response) {
                    if (response.success) {
                        otpPopup.removeClass('d-none');
                        loginPopup.addClass('d-none').parents('.modal-dialog').addClass('otp-modal-dialog');
                        $('.resent-otp-mobilenumber').empty().text(mobile);
                        $('.resent-otp-mobilenumber').removeClass('pl-2');
                        if (!$('#some-div .count')[0]) {
                            $('#some-div').append('<span class="count"></span>');
                        }
                        clearTimeout(timerId);
                        startCountdown();
                        showCountDownOnResendLink();
                        timerId = setInterval(countdown, 1000);
                        $('.otp-input')[0].focus();
                        countdownWithSync();
                    }
                },
                error: function () { }
            });
        }
    }
});

/**
 * Set the otp boxes
 */

$('.otp-input').keydown(function (e) {
    if (e.keyCode === 8 || e.code === 'Backspace') {
        if ($(this).val() === '') $(this).prev('.otp-input').focus();
    }
});

$('.otp-input').keyup(function (e) {
    if (!(e.keyCode === 8 || e.code === 'Backspace') && $(this).val().length.toString() === $(this).attr('maxlength')) {
        $(this).next('.otp-input').focus();
    }
    var counter = 0;
    $('.otp-input').each(function () {
        if ($(this).val() !== '') counter += 1;
    });
    if (counter > 5) {
        $('.otp-input').addClass('input-filled');
    } else {
        $('.otp-input').removeClass('input-filled');
    }
});

$('.otp-input').keypress(function (event) {
    return /[0-9]/i.test(event.key);
});

$('.otp-input').focus(function () {
    $(this).click();
    $('.otp-input').removeClass('error');
});

$('#login-popup .otp-input').on('click', function () {
    $(this).select();
    $('.otp-input').removeClass('error');
});

let isOTPValid = true;

$('body').on('OTPpasted', function () {
    isOTPValid = false;
});

$(document).on('keyup', '.otp-input', function (event) {
    if (event.which === 229) return;

    if (event.which === 13 && !isIOSSafari()) {
        $('.otppopup-submitbutton').click();
        return;
    }
    const isAnyOTPMissing = Array.from($(this).closest('.otp-boxes-otp').find('.otp-input')).some(function (input) {
        return $(input).val() === '';
    });

    if (!isAnyOTPMissing && isOTPValid) {
        $(this).closest('.login-popup-modal-container').find('.otppopup-submitbutton').trigger('click');
        isOTPValid = false;
    }
});

$(document).on('input', '.otp-input', function () {
    let previousValue = $(this).data('previousValue');
    let currentValue = $(this).val();

    if (previousValue !== currentValue) {
        isOTPValid = true;
        $(this).data('previousValue', currentValue);
    }
    $(this).val($(this).val().replace(/[^0-9]/g, ''));

    $('.otp-error').addClass('d-none');
    $('.otp-error').closest('.otpfeilds').removeClass('error');
    $('.otp-below-text-question').removeClass('error-displayed');
});

$(document).ready(function () {
    init();
    $('#loginPopupModal').on('hidden.bs.modal', function () {
        loginPopup.find('.loginpopup-submitbutton').attr('disabled', 'disabled');
        loginPopup.find('.loginpopup-formdiv').removeClass('error');
        var errormsg = loginPopup.find('.phoneno-field .error-message');
        errormsg.removeClass('d-block');
        clearTimeout(timerId);
        timeLeft = 60;
        timerId = setInterval(countdown, 1000);
        loginPopup.find('.mobile-number').val('');
        $('#salutationField').val('');
        $('#salutationDropdown').prop('selectedIndex', 0);
        var defaultSalutation = $('#salutationDropdown option:selected').val();
        $('#salutationField').val(defaultSalutation + '.');
        $('.salutation-option-values li').removeClass('selected');
        $('.salutation-option-values li').first().addClass('selected');
        errormsg.removeClass('error');
        loginPopup.find('.phone-number-field .clear-number-btn').addClass('d-none');
        registerpopup.addClass('d-none');
        registerpopup.find('.register-form-lastname').val('');
        registerpopup.find('.register-form-firstname').val('');
        registerpopup.find('.email').val('');
        otpPopup.addClass('d-none');
        $('.otp-verification-section').find('.otp-input').val('');
        $('.otp-error').addClass('d-none');
        $('.otp-error').closest('.otpfeilds').removeClass('error');
        $('.py-form-field').removeClass('error-class');
        $('.py-form-field').find('.error-message').addClass('d-none');
        loginPopup.removeClass('d-none');
        $('#loginCountryDropdown').val('');
        var countryValue = $('#loginCountryDropdown').attr('country-value');
        $('#loginCountryDropdown').val(countryValue);
        var countryFlag = $('#hiddenFlag').val();
        $('.country-flag img').attr('src', countryFlag);
        $('body').removeClass('login-modal-open');
    });

    $('.login-phone-field').on('keyup keypress blur change', function (e) {
        if (e.type === 'blur' || e.type === 'keyup' || $(this).hasClass('show-error')) {
            $(this).addClass('show-error');
            loginValidation(e.target);
        }
    });

    $('.mobile-number').on('focus input', function () {
        var $parentEle = $(this).closest('.phoneno-field');
        var isEmpty = $(this).val().trim() === '';
        var minLength = $('#mobileNumber').attr('minlength');

        $parentEle.siblings('#default-error').toggleClass('d-none', !isEmpty);
        if ($(this).val().length >= minLength) {
            $('.clear-number-btn').removeClass('d-none');
        } else {
            $('.clear-number-btn').addClass('d-none');
        }
    });

    $('.clear-number-btn').on('click', function () {
        $('.mobile-number').val('');
        $(this).addClass('d-none');
        var popupSection = $(this).closest('.login-popup-section');
        $(this).closest('.phoneno-field').find('#default-error').addClass('d-block');
        popupSection.find('.request-otp-btn .loginpopup-submitbutton').attr('disabled', 'disabled');
    });

    $('.login-phone-field').on('input keypress', function () {
        $(this).val($(this).val().replace(/[^0-9]/g, ''));
    });

    $('.login-phone-field').keyup(function (event) {
        if (event.which === 13) {
            $(this).closest('.login-form').find('.loginpopup-submitbutton').click();
        }
    });
});

$('.otppopup-submitbutton').click(async function (e) {
    e.preventDefault();
    var loginpopup = $('.login-popup-modal-container');
    var $form = $(this).parents('.otp-verification-section').find('#otp-form');
    var parent = $(this).closest('.login-popup-modal-container');
    var phoneno = parent.find('.phoneno-field .mobile-number').val();
    var phoneInput = loginpopup.find('.registration-form-section .mobileinputfield-form');

    var inputs = $form.find("input[type='tel']");
    var otp = '';
    inputs.each(function () {
        otp += $(this).val();
    });
    var allEmpty = Array.from(inputs).every(function (input) {
        return $(input).val() === '';
    });
    var partiallyFilled = Array.from(inputs).some(function (input) {
        return $(input).val() === '';
    }) && !allEmpty;

    if (allEmpty) {
        $form.find('.otp-input').addClass('error');
        $form.find('.otp-error').text($('.otp-empty-verification').val());
        $form.find('.otp-error').removeClass('d-none');
        $('.otp-error').closest('.otpfeilds').addClass('error');
        $form.find('.resend-otp-section').addClass('error-displayed');
        return;
    }
    if (partiallyFilled) {
        $form.find('.otp-input').addClass('error');
        $form.find('.otp-error').text($('.otp-incomplete-verification').val());
        $form.find('.otp-error').removeClass('d-none');
        $('.otp-error').closest('.otpfeilds').addClass('error');
        $form.find('.resend-otp-section').addClass('error-displayed');
        return;
    }
    const actionitems = {
        isWishlistRedirect: !!window.isWishlistRedirect,
        isWishlistItem: !!window.isWishlistItem,
        wishlistPID: window.wishlistPID ? window.wishlistPID : null,
        redirectToLiveShoppingPage: window.redirectToLiveShoppingPage,
        redirectToSavingSchemePage: window.redirectToSavingSchemePage,
        redirectToJoinScheme: window.redirectToJoinScheme || null
    };
    $.spinner().start();
    $('body .veil').addClass('veil-index');
    var url = $(this).data('verifyotpurl');

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            otp: otp,
            phoneno: phoneno,
            actionitems: JSON.stringify(actionitems),
            recaptchaToken: await grecaptchaGenerateToken()
        },
        success: function (response) {
            if (response.success) {
                if (response.customerExists) {
                    if (response.redirectURL != null) {
                        window.location.href = response.redirectURL;
                    } else {
                        $('.otp-error').addClass('d-none');
                        $('.otp-error').closest('.otpfeilds').removeClass('error');
                        sessionStorage.setItem('loginToast', response.message);
                        sessionStorage.setItem('wishlistToast', response.wishlistToast);
                        window.location.reload();
                    }
                } else {
                    $('.otp-verification-section').addClass('d-none');
                    registerpopup.removeClass('d-none');
                    $('.registration-form-section .register-form-phoneno').addClass('disabled');
                    $('.registration-form-section .register-form-phoneno').find('#phone-number').val(phoneno);
                    $('.registerpopup-formdiv #floating-label-group').find('.clear-number-btn').addClass('d-none');
                    preventPhoneNumberChange(phoneInput, phoneno);
                    var selectedCountryVal = $('#loginCountryDropdown').val();
                    var selectedFlag = $('.login-dropdown .py-custom-select-label').find('img').attr('src');
                    var registerFormContainer = $('.registration-form-section').find('.register-country-section');
                    registerFormContainer.find('.country-img').attr('src', selectedFlag);
                    registerFormContainer.find('.py-custom-select-input').val(selectedCountryVal);
                    $.spinner().stop();
                }
            } else {
                $.spinner().stop();
                $('.otp-input').addClass('error');
                if (response.message) {
                    $('.otp-error').html(response.message);
                }
                $('.otp-error').removeClass('d-none');
                $('.otp-error').closest('.otpfeilds').addClass('error');
                $('.resend-otp-section').addClass('error-displayed');
            }
        },
        error: function () { }
    });
});

$('.otp-verification-section input[type="tel"]').on('input', function () {
    var $form = $(this).closest('#otp-form');
    var allEmpty = true;

    $form.find("input[type='tel']").each(function () {
        if ($(this).val() !== '') {
            allEmpty = false;
        }
    });
    if (allEmpty) {
        $('.otp-error').addClass('d-none');
        $('.otp-input').removeClass('error');
        $('.otp-error').closest('.otpfeilds').removeClass('error');
    }
});
$('#resendLink').on('click', async function () {
    var mobile = $('.login-popup-modal-container').find('.phoneno-field .mobile-number').val();
    $('.resent-otp').addClass('d-block');
    $('.otp-sub-title-text').addClass('d-none');
    $('.otp-error').addClass('d-none');
    $('.otp-boxes-otp input').removeClass('error');
    $('.otp-below-text-question').removeClass('error-displayed');
    var { csrfTokenName, csrfTokenValue } = getCSRFTokenForLogin();

    $.ajax({
        url: $(this).data('resendotpurl'),
        type: 'post',
        dataType: 'json',
        data: {
            mobile: mobile,
            [csrfTokenName]: csrfTokenValue,
            recaptchaToken: await grecaptchaGenerateToken()
        },
        success: function (response) {
            if (response.success) {
                var $form = otpPopup;
                $form.find("input[type='tel']").each(function () {
                    $('.otp-input').val('');
                });
                clearTimeout(timerId);
                startCountdown();
                showCountDownOnResendLink();
                timerId = setInterval(countdown, 1000);
                $('.otp-input')[0].focus();
                countdownWithSync();
                $('.otp-boxes-otp .otp-input:first').focus();
            } else if (response.errorMessage) {
                $('.otp-input').addClass('error');
                $('.otp-error').removeClass('d-none');
                $('.otp-below-text-question').addClass('error-displayed');
            }
        },
        error: function () { }
    });
});

$(document).on('change', '#countrySelector', function () {
    var parent = $(this).closest('.loginpopup-formdiv');
    var selectedCode = $(this).val().trim();
    var countryJson = JSON.parse($('#countriesConfig').val());
    for (const item of countryJson) {  // eslint-disable-line
        var countryName = Object.keys(item)[0];
        var countryCodeselected = item[countryName].countryCode;
        if (countryCodeselected === selectedCode) {
            var minLen = item[countryName].dynamicForms.addressDetails.phone['min-length'];
            var maxLen = item[countryName].dynamicForms.addressDetails.phone['max-length'];
            parent.find('.selected-countries-length .countries-length').attr('maxlength', maxLen);
            parent.find('.selected-countries-length .countries-length').attr('minlength', minLen);
            break;
        }
    }
});

$('.registerpopup-formdiv #first-name').on('keyup', function () {
    checkFirstName($('#first-name'));
});

$('.registerpopup-formdiv #last-name').on('keyup', function () {
    checkLastName($('#last-name'));
});

$('.registerpopup-formdiv #email').on('keyup', function () {
    checkEmail();
});

$(document).on('click', '.registerpopup-submitbutton', async function (e) {
    e.preventDefault();
    var validationError = 0;
    var mobile = $('.login-popup-modal-container').find('.phoneno-field .mobile-number').val();
    var firstName = $('.register-form-firstname');
    var lastName = $('.register-form-lastname');
    var firstNameValue = firstName.val().trim();
    var lastNameValue = lastName.val().trim();
    var email = registerForm.find('#email');
    var emailValue = email.val();
    var salutation = registerForm.find('.py-custom-select-input').val();
    var regExpEmail = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
    var regFirstName = /^[a-zA-Z0-9.]+$/;
    var regLastName = /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)?$/;
    var countryCode = $('#loginCountryDropdown').val();
    var locale = $('.login-dropdown .py-option-value.selected').data('value');

    if (firstNameValue === '' || !regFirstName.test(firstNameValue) || firstNameValue.length < 1) {
        $('#blank-firstname').removeClass('d-none');
        firstName.parent().addClass('error-class');
        validationError = 1;
    }
    if (lastNameValue === '' || !regLastName.test(lastNameValue) || lastNameValue.length < 1) {
        $('#blank-lastname').removeClass('d-none');
        lastName.parent().addClass('error-class');
        validationError = 1;
    }

    if (emailValue === '' || !regExpEmail.test(emailValue)) {
        $('#blank-email').removeClass('d-none');
        email.parent().addClass('error-class');
        validationError = 1;
    }
    if (!salutation) {
        $('#blank-salutation').removeClass('d-none');
        validationError = 1;
    } else {
        $('#blank-salutation').addClass('d-none');
    }

    const actionitems = {
        isWishlistRedirect: !!window.isWishlistRedirect,
        isWishlistItem: !!window.isWishlistItem,
        wishlistPID: window.wishlistPID ? window.wishlistPID : null,
        redirectToLiveShoppingPage: window.redirectToLiveShoppingPage,
        redirectToSavingSchemePage: window.redirectToSavingSchemePage,
        redirectToJoinScheme: window.redirectToJoinScheme || null
    };

    if (validationError) {
        return false;
    }
    $.spinner().start();
    $('body .veil').addClass('veil-index');
    var { csrfTokenName, csrfTokenValue } = getCSRFTokenForLogin();
    var url = registerForm.attr('action');

    $.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        data: registerForm.serialize() + '&countryCode=' + encodeURIComponent(countryCode) + '&phone=' + encodeURIComponent(mobile) + '&actionitems=' + encodeURIComponent(JSON.stringify(actionitems)) + '&locale=' + encodeURIComponent(locale) + '&recaptchaToken=' + await grecaptchaGenerateToken() + '&' + csrfTokenName + '=' + encodeURIComponent(csrfTokenValue),
        success: function (response) {
            if (response.success) {
                $.spinner().stop();
                sessionStorage.setItem('loginToast', response.message);
                if (response.redirectURL != null) {
                    window.location.href = response.redirectURL;
                } else {
                    $('.login-popup-modal').removeClass('show');
                    $('.login-popup-modal').hide();
                    $('body').trigger('successToast', response.message);
                    sessionStorage.setItem('wishlistToast', response.wishlistToast);
                    window.location.reload();
                }
            } else {
                $('.register-form-error').html(response.message).removeClass('d-none');
                $('.login-popup-modal').addClass('hide');
                window.location.reload();
            }
        },
        error: function () {
            $.spinner().stop();
            window.location.reload();
        }
    });
    return '';
});

$(document).ready(function () {
    $('.form-control').on('focus input', function () {
        let $parent = $(this).closest('.form-field');
        let $clearBtn = $parent.find('.clear-number-btn');

        if ($(this).val().trim() !== '') {
            $clearBtn.removeClass('d-none');
        } else {
            $clearBtn.addClass('d-none');
        }
    });

    $('.clear-number-btn').on('click', function () {
        let $input = $(this).siblings('input');
        $input.val('').trigger('input').focus();
        $(this).addClass('d-none');
        $('.phoneno-field').removeClass('error');
        $('#valid-error').removeClass('d-block');
    });
});

$(window).on('load', function () {
    var toastKeys = ['loginToast', 'wishlistToast'];
    toastKeys.forEach(function (key) {
        var value = sessionStorage.getItem(key);
        if (value !== null && value !== 'null' && value.trim() !== '') {
            $('body').trigger('successToast', [value, true]);
            sessionStorage.removeItem(key);
        }
    });
});

$('#loginPopupModal').on('shown.bs.modal', function () {
    $('body').addClass('login-modal-open');
});
